export enum LegacyUserProfileActionRows {
  Wealth = 'wealth',
  Cash = 'cash',
  Trade = 'trade',
  Dashboard = 'dashboard'
}

export enum LegacyUserProfileActions {
  Builder = 'start_builder',
  Register = 'start_register',
  Suitability = 'start_suitability',
  Dashboard = 'start_dashboard'
}

export interface ILegacyUserProfileRow {
  type: LegacyUserProfileActionRows;
  title: string;
  description: string;
  action: LegacyUserProfileActions;
  tags?: string[];
}

interface ILegacyUserProfileButton {
  label: string;
  action: string;
}

export interface ILegacyUserProfile {
  title: string;
  quote: string;
  description: string;
  riskLevel: string;
  actionRows: ILegacyUserProfileRow[];
  actionButton: ILegacyUserProfileButton;
}
